const SEMVER_PATTERN = /^\d+\.\d+\.\d+$/;
export function isSemver(value) {
    return SEMVER_PATTERN.test(value);
}
export function compareSemver(a, b) {
    const pa = a.split('.').map(Number);
    const pb = b.split('.').map(Number);
    for (let i = 0; i < 3; i++) {
        const na = pa[i] || 0;
        const nb = pb[i] || 0;
        if (na < nb)
            return -1;
        if (na > nb)
            return 1;
    }
    return 0;
}
//# sourceMappingURL=semver.utils.js.map